import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import { colors } from '../../styles';
import Filters from '../../components/Filters';
import AreaInfo from '../../components/AreaInfo';
import CommunitiesResults from './CommunitiesResults';

const styles = css`
  .Communities_communitiesResults {
    display: flex;
    position: relative;
    z-index: 1;
  }

  .Communities_communitiesList {
    display: none;
    height: auto;
    @media (min-width: 992px) {
      display: block !important;
      width: 542px;
      padding: 30px;
      background-color: #f5f5f6;
      padding: 20px;
      height: 945px;
      overflow-y: scroll;
    }
  }
  .AreaInfo {
    width: 100%;
    padding: 100px 0 0 0;
    display: flex;
    .AreaInfo_media {
      margin: 0 0 15px 0;
      img {
        width: 100%;
        height: auto;
      }
    }
    .AreaInfo_content {
      .AreaInfo_title {
        font-weight: 200;
        font-size: 70px;
        color: ${colors.brand1};
        line-height: 80px;
        margin: 0 0 60px 0;
        position: relative;
        &:after {
          content: '';
          display: block;
          width: 200px;
          height: 3px;
          position: absolute;
          bottom: -10px;
          left: 0;
          background-color: ${colors.neutral};
        }
        @media (min-width: 992px) {
          font-size: 120px;
          line-height: 114px;
        }
      }
      .AreaInfo_postTitle {
        font-weight: 900;
        font-size: 24px;
        color: ${colors.brand2};
        display: block;
        @media (min-width: 992px) {
          font-size: 32px;
        }
      }
      .AreaInfo_body {
        font-weight: 300;
        font-size: 19px;
        line-height: 35px;
        color: ${colors.brand2};
      }
    }
  }

  .WelcomeWrapper {
    padding: 4vh 5vw 2vh;
    @media(min-width: 768px) {
      padding: 3vh 25px 1vh;
    }

    h1 {
      font-size: 26px;
      color: ${colors.brand2};
      letter-spacing: -0.38px;
      text-align: center;
      @media(min-width: 992px) {
        font-size: 50px;
        letter-spacing: -0.73px;
        text-align: left;
      }
    }
  }
`;
const toggle = css`
  display: inline-block;
  margin: 0 10px 0 0;
  @media(min-width: 992px) {
  }
  span {
    display: block;
    font-size: 14px;
    align-items: center;
    cursor: pointer;
    height: 50px;
    line-height: 50px;
    text-transform: uppercase;
    transition: all .3s ease-out;
    padding: 0 10px;
    &:hover {
      color: ${colors.brand2};
      transition: all .3s ease-out;
    }
    i {
      margin-right: 5px;
    }
  }
`;
const toggleFilters = css`
  display: inline-block;
  margin: 0 10px 0 0;
  @media(min-width: 992px) {
    display: none;
  }
  span {
    display: block;
    font-size: 14px;
    align-items: center;
    cursor: pointer;
    height: 50px;
    line-height: 50px;
    text-transform: uppercase;
    transition: all .3s ease-out;
    padding: 0 10px;
    &:hover {
      color: ${colors.brand2};
      transition: all .3s ease-out;
    }
    img {
      margin-right: 5px;
      height: 14px;
      width: auto;
    }
  }
`;
const statusList = [
  'Active',
  'Coming Soon',
  'Sold',
];

const statusOrder = home => (
  statusList.indexOf(home.status) > -1
    ? statusList.indexOf(home.status)
  : 99
);

const sortOptions = [
  { title: 'Status', field: [statusOrder], dir: ['asc'] },
];

class Communities extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isToggle: false,
      isToggleFilter: null,
      sort: sortOptions[0],
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize.bind(this));
    this.resize();
  }

  setSort(sort) {
    const dir = sort.dir || 'asc';
    this.setState({
      sort: { ...sort, dir },
    });
  }

  resize() {
    this.setState({
      isToggleFilter: window.innerWidth >= 991,
    });
  }

  toggleClick = () => {
    this.setState({
      isToggle: !this.state.isToggle,
    });
  }
  toggleClickFilters = () => {
    this.setState({
      isToggleFilter: !this.state.isToggleFilter,
    });
  }

  render() {
    const { area, metro, submetro, page, areas, builder } = this.props;
    const { isToggle, isToggleFilter, sort } = this.state;
    const selectedArea = submetro || metro || area || areas.filter(item => item.default_area)[0];
    return (
      <PageWrapper>
        <PageHelmet
          custom
          title={`${get(page, 'meta.name')} in ${get(selectedArea, 'name', 'Seattle Metro Area')}`}
        >
          <meta
            name="description"
            content={`Browse through new home communities in ${get(selectedArea, 'name', 'the Seattle Metro Area')} from home builder ${get(builder, 'name')}.`}
          />
        </PageHelmet>

        <InsideHeader
          h1={`${page.meta.name}`}
          background={get(page, 'page_image.contentUrl')}
        />
        <div className={styles}>
          <div className={toggle}>
            {
              isToggle &&
              <span onClick={this.toggleClick} role="button" tabIndex={0}><i className="far fa-map" /> Map View</span>
            }
            {
              !isToggle &&
              <span onClick={this.toggleClick} role="button" tabIndex={0}><i className="fas fa-th" /> Grid View</span>
            }
          </div>
          <div className={toggleFilters}>
            <span role="button" tabIndex={0} onClick={this.toggleClickFilters}><img src="/images/icon-filter-gray.svg" alt="Filter Icon" />{!isToggleFilter ? 'Show' : 'Hide'} Filters</span>
          </div>

          {
            isToggleFilter &&
            <Filters
              type="communities"
              filterOptions={[
                {
                  type: 'SingleSelect',
                  filter: 'Area',
                  title: 'City',
                  placeholder: 'All Cities',
                  routeParam: 'communityMarketArea',
                  onlyFilters: [],
                },
                {
                  type: 'MultiSelect',
                  filter: 'SchoolDistrict',
                  title: 'School Districts',
                  placeholder: 'All Districts',
                },
                {
                  type: 'SingleSelect',
                  filter: 'Community',
                  title: 'Community',
                  placeholder: 'All Communities',
                },
              ]}
              clearButton={<span>Reset Filter <img src="" alt="Reset Filters Icon" /></span>}
            />
          }
          <CommunitiesResults isToggle={isToggle} sort={sort} />
          <AreaInfo />
        </div>
      </PageWrapper>
    );
  }
}

Communities.propTypes = {
  area: PropTypes.object,
  areas: PropTypes.arrayOf(PropTypes.object).isRequired,
  metro: PropTypes.object,
  submetro: PropTypes.object,
  page: PropTypes.object.isRequired,
  builder: PropTypes.object.isRequired,
};

Communities.defaultProps = {
  area: undefined,
  metro: undefined,
  submetro: undefined,
};

export default withData(
  {
    area: true,
    areas: 'all',
    metro: true,
    submetro: true,
    page: 'communities',
    builder: true,
  },
  {
    required: {
      page: true,
      areas: true,
      builder: true,
    },
    ifMissing404: true,
  },
)(Communities);



// WEBPACK FOOTER //
// ./src/pages/Communities/index.js